import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DocumentTableData } from '@/types/depo20';

interface ApiResponse<T> {
  value: T;
}

interface IAddProforma {
  numero: number | null;
}

export const getProformaNumber = async (
  query: IAddProforma
): Promise<DocumentTableData> => {
  try {
    const res = await apiClient.post<ApiResponse<DocumentTableData>>(
      Endpoints.ObtenerNumeroProforma,
      {
        numero: query.numero,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
